// Sponsorship Firestore helpers — reads are public; writes are client-side mock
// until a backend (Cloud Function / Stripe webhook) is wired up.
import {
    collection,
    doc,
    onSnapshot,
    serverTimestamp,
    setDoc,
    increment,
} from 'firebase/firestore';
import { db } from '../firebase/config';
import { SPONSORSHIP_COLLECTION, SPONSOR_AMOUNT_TWD } from '../data/sponsor-constants';

export const isFirebaseReady = () => Boolean(db && db._delegate);

// Subscribe to the sponsorships collection. Returns unsubscribe fn or null.
// Callback receives a map: { [projectId]: { coffeeCount, mocktailCount, coffeeTotalTWD, mocktailTotalTWD, lastSponsoredAt } }
export const subscribeSponsorships = (cb) => {
    if (!isFirebaseReady()) return null;
    const ref = collection(db, SPONSORSHIP_COLLECTION);
    return onSnapshot(ref, (snap) => {
        const map = {};
        snap.forEach((d) => {
            const data = d.data() || {};
            map[d.id] = {
                coffeeCount: data.coffeeCount || 0,
                mocktailCount: data.mocktailCount || 0,
                coffeeTotalTWD: data.coffeeTotalTWD || 0,
                mocktailTotalTWD: data.mocktailTotalTWD || 0,
                lastSponsoredAt: data.lastSponsoredAt?.toMillis
                    ? data.lastSponsoredAt.toMillis()
                    : 0,
            };
        });
        cb(map);
    });
};

// Record a sponsorship. Client-side write — used while backend is not yet deployed.
// TODO: replace with Cloud Function trigger off a Stripe webhook to prevent spoof.
export const recordSponsorship = async (projectId, type) => {
    if (!isFirebaseReady()) return;
    const amount = SPONSOR_AMOUNT_TWD[type] || 0;
    const countField = type === 'coffee' ? 'coffeeCount' : 'mocktailCount';
    const totalField = type === 'coffee' ? 'coffeeTotalTWD' : 'mocktailTotalTWD';
    const ref = doc(db, SPONSORSHIP_COLLECTION, projectId);
    await setDoc(
        ref,
        {
            [countField]: increment(1),
            [totalField]: increment(amount),
            lastSponsoredAt: serverTimestamp(),
        },
        { merge: true }
    );
};
